import "./App.css";
import Footer from "./Components/Footer";
import Header from "./Components/Header";
import CourseDetail from "./page/CourseDetail";
import HomePage from "./page/HomePage/index.jsx";
import CourseQcTop from "./Components/CourseQcTop";
import Social from "./Components/Social";
import Blogs from "./page/BlogListPage";
import BlogAuthGoogleWithReact from "./page/Blogs/BlogAuthGoogleWithReact";
import OperatorJS from "./page/Blogs/OperatorJs";
import BlogClosureForBeginner from "./page/Blogs/Closure";
import { Route, Routes } from "react-router-dom";

function App() {
  return (
    <div className="app">
      <Social />
      <CourseQcTop />
      <Header />
      <Routes>
        <Route path="" element={<HomePage />} />
        <Route path="/course/react-chuyen-sau" element={<CourseDetail />} />
        <Route path="/blog" element={<Blogs />} />
        <Route
          path="/blog/authentication-google-voi-react"
          element={<BlogAuthGoogleWithReact />}
        />
        <Route
          path="/blog/nhung-cau-lenh-dieu-kien-javascript-quan-trong"
          element={<OperatorJS />}
        />
        <Route
          path="/blog/bo-tui-closure-trong-5-phut"
          element={<BlogClosureForBeginner />}
        />
      </Routes>
      <Footer />
      <canvas className="canvas-bg"></canvas>
    </div>
  );
}

export default App;
